import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

const featureContentTwo = [
    {
        icon: 'icon-9a',
        title: '요구사항 분석',
        desc: '비즈니스 목표와 현재 업무 프로세스를 심층 분석하여 실현 가능한 IT 솔루션 방향을 도출합니다.',
        dataAos: 'fade-up',
        dataDelay: ''
    },
    {
        icon: 'icon-10a',
        title: '아키텍처 설계',
        desc: '확장성과 운영 안정성을 고려한 시스템 구조를 설계하고, 기술 스택과 개발 범위를 확정합니다.',
        dataAos: 'fade-up',
        dataDelay: '100'
    },
    {
        icon: 'icon-11a',
        title: '애자일 개발',
        desc: '2주 단위 스프린트로 지속적인 피드백을 반영하며 투명하게 개발을 진행합니다.',
        dataAos: 'fade-up',
        dataDelay: '200'
    },
    {
        icon: 'icon-12a',
        title: '품질 검수',
        desc: '실제 운영 환경 기준의 부하 테스트, 보안 점검, 기능 검수로 납품 품질을 보장합니다.',
        dataAos: 'fade-up',
        dataDelay: '300'
    },
    {
        icon: 'icon-10a',
        title: '배포 및 운영 지원',
        desc: '무중단 배포와 초기 안정화 집중 지원, 운영 매뉴얼 제공으로 안정적인 서비스 런칭을 지원합니다.',
        dataAos: 'fade-up',
        dataDelay: '400'
    },
]

const FeatureTwo = () => {
  return (
    <Fragment>
        {featureContentTwo.map((val, i)=>(
            <div key={i} className="col-lg-4 col-md-6" data-aos={val.dataAos} data-aos-delay={val.dataDelay}>
                <div className="feature-style-two mb-45">
                    <div className="icon"><img src={`assets/img/icon/${val.icon}.png`} alt={`${val.title} 아이콘`} /></div>
                    <h3>
                        <Link to="/faq">{val.title}</Link>
                    </h3>
                    <p>{val.desc}</p>
                </div>
            </div>
        ))}
    </Fragment>
  )
}

export default FeatureTwo
